export const getUser = state => state.user;
export const getToken = state => state.user.token;
export const getUserProfile = state => state.user.user;



// WEBPACK FOOTER //
// ./src/shared/selectors/user.js